// 2026-10-26 오너 — 사업팀 엑셀 '권역별현황, 계약현황'을 사업 대시보드로 옮긴다.
// 콘솔 데이터로 자동 집계하고, 사람은 달마다 목표치를 넣거나 시도별 칸을 보정할 수 있다.
//
// 권역 · 시도 순서는 엑셀 '권역별 현황1' 표 그대로다(사업팀이 보던 순서를 바꾸지 않는다).
/** 권역 → 시도. 해외는 시도 없이 권역 하나로 센다. */
export const BUSINESS_REGION_GROUPS = [
    { group: '수도권', sidos: ['경기', '서울', '인천'] },
    { group: '경상권', sidos: ['부산', '경남', '경북', '울산', '대구'] },
    { group: '호남권', sidos: ['전북', '전남', '광주'] },
    { group: '충청권', sidos: ['충남', '대전', '충북', '세종'] },
    { group: '제주', sidos: ['제주'] },
    { group: '강원', sidos: ['강원'] },
    { group: '해외', sidos: ['해외'] },
];
/** 지역을 알 수 없는 건 — 엑셀 '미확인' 줄. */
export const BUSINESS_REGION_UNKNOWN = '미확인';
/** 지표 — 문의(IB) · 데모 · 계약 건수 · 계약 대수 · 설치 매장 · 설치 대수. */
export const BUSINESS_REGION_METRICS = [
    'ib',
    'demo',
    'contracts',
    'contractUnits',
    'liveStores',
    'liveUnits',
];
export const BUSINESS_REGION_METRIC_LABEL = {
    ib: '문의',
    demo: '데모',
    contracts: '계약',
    contractUnits: '계약 대수',
    liveStores: '설치 매장',
    liveUnits: '설치 대수',
};
/** 사람이 넣는 값 — 목표치(TARGET, 달 전체) 또는 보정(OVERRIDE, 시도 한 칸). */
export const BUSINESS_REGION_INPUT_KINDS = ['TARGET', 'OVERRIDE'];
const SIDO_ALIASES = [
    [/^서울/, '서울'],
    [/^부산/, '부산'],
    [/^대구/, '대구'],
    [/^인천/, '인천'],
    [/^광주/, '광주'],
    [/^대전/, '대전'],
    [/^울산/, '울산'],
    [/^세종/, '세종'],
    [/^경기/, '경기'],
    [/^강원/, '강원'],
    [/^(충북|충청북)/, '충북'],
    [/^(충남|충청남)/, '충남'],
    [/^(전북|전라북)/, '전북'],
    [/^(전남|전라남)/, '전남'],
    [/^(경북|경상북)/, '경북'],
    [/^(경남|경상남)/, '경남'],
    [/^제주/, '제주'],
    [/^(해외|국외|overseas)/i, '해외'],
];
/**
 * 지역 글자 → 시도('경기') · '해외' · null(알 수 없음).
 * '경기도 성남시', '경상북도', '충청남도 천안' 처럼 앞머리만 보고 정한다.
 */
export function toBusinessSido(text) {
    const s = (text ?? '').trim();
    if (!s)
        return null;
    for (const [re, sido] of SIDO_ALIASES)
        if (re.test(s))
            return sido;
    return null;
}
/** 시도 → 권역. 모르는 값은 null. */
export function businessRegionGroupOf(sido) {
    for (const g of BUSINESS_REGION_GROUPS)
        if (g.sidos.includes(sido))
            return g.group;
    return null;
}
export function emptyBusinessRegionValues() {
    return { ib: 0, demo: 0, contracts: 0, contractUnits: 0, liveStores: 0, liveUnits: 0 };
}
//# sourceMappingURL=business-regions.js.map